import { useState, useEffect } from 'react'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import { formatDate, getAllData, subtractDays } from '../../shared/constants'

const LeaderBoardReport = () => {
  const [state, setState] = useState({
    data: [],
    loading: false,
    paginate: false,
    downloadData: false,
  })

  const filterData = state.data
  const [page, setPage] = useState(1)

  //? useEffect
  useEffect(() => {
    getAllData('GET_LEADER_BOARD_REPORT', { page: page, limit: 10 }, state, setState)
  }, [page])

  const handleChange = (event, value) => {
    setPage(value)
  }

  let tableBody = []

  console.log({ filterData })
  console.log({ state })

  if (!state.loading && filterData.length > 0) {
    tableBody = filterData.map((item, index) => {
      return [
        { value: item?.employee },
        { value: item?.region },
        { value: item?.zone },
        { value: item?.total },
        { value: item?.attendance },
        { value: item?.sales },
        { value: item?.learning },
        { value: item?.audit },
      ]
    })
  }

  const layoutProps = {
    heading: 'Leader Board Report',
    filename: 'leaderBoardReport',
    headers: state.downloadData.headings,
    data: state.downloadData.headingValues,
  }

  return (
    <CustomTableLayout
      tableHeadings={['Employee', 'Region', 'Zone', 'Total Score', 'Attendence', 'Sales', 'Learning', 'Audit']}
      loading={state.loading}
      tableBody={tableBody}
      handlePageChange={handleChange}
      paginate={{ totalPage: state.paginate.totalPage, page: page }}
      layoutProps={layoutProps}
    />
  )
}

export default LeaderBoardReport
